import script from "./FrotaDespesasPorGrupoPieChart.vue?vue&type=script&setup=true&lang=js"
export * from "./FrotaDespesasPorGrupoPieChart.vue?vue&type=script&setup=true&lang=js"

import "./FrotaDespesasPorGrupoPieChart.vue?vue&type=style&index=0&id=46c9d9a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46c9d9a2"]])

export default __exports__